
import './App.css';
import Weather from "./Weather";


function App() {
  return (
    <div className="App">
    <div className="container">
   
     <Weather city="Amsterdam"/>
     <footer>
       This project was coded by <a href="https://www.linkedin.com/in/ekaterinabilenko/" target="_blank">Ekaterina Bilenko</a> and is <a href="https://github.com/KatyaAms/Final-project-React" target="_blank">open-sourced on GitHub</a>
     </footer>
    </div>
    </div>
  );
}

export default App;
